import React, { useState, useEffect } from 'react';
import './ActivitiesPage.css';
import { BASE_API_URL } from '../config/constants';

function ActivitiesPage({ user }) {
    const [activities, setActivities] = useState([]);
    const [newActivity, setNewActivity] = useState({ name: '', date: '', description: '' });
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        //have to get the userId from an token
        const userId = '018923e0-3102-44e4-9330-55789aa816a3'; 
        if (userId) {
            fetch(`${BASE_API_URL}api/activities/user/${userId}`)
                .then(response => response.json())
                .then(data => setActivities(data))
                .catch(error => console.error(error));
        }
    }, [user]);

    const handleAddActivity = () => {
        // TODO: Replace hardcoded userId with a signed token to retrieve user details dynamically.
        const userId = "018923e0-3102-44e4-9330-55789aa816a3";

        fetch(`${BASE_API_URL}api/activities`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: newActivity.id,
                name: newActivity.name,
                date: newActivity.date,
                description: newActivity.description,
                userId,
            }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to add activity: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if (!data || !data.name) {
                    throw new Error('Invalid activity data received');
                }
                setActivities([...activities, data]);
                setErrorMessage('');
            })
            .catch(error => {
                console.error(error);
                setErrorMessage(error.message);
            });
    };

    const handleDeleteActivity = (id) => {
        if (!id) {
            console.error('Activity ID is undefined. Ensure the activity object has a valid ID.', activities);
            return;
        }

        fetch(`${BASE_API_URL}api/activities/${id}`, {
            method: 'DELETE',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to delete activity: ${response.statusText}`);
                }
                setActivities(activities.filter(activity => activity.id !== id));
            })
            .catch(error => {
                console.error(error);
                setErrorMessage(error.message);
            });
    };

    const handleUpdateActivity = (id, updatedActivity) => {
        fetch(`${BASE_API_URL}api/activities/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedActivity),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to update activity: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if (!data || !data.name) {
                    throw new Error('Invalid activity data received');
                }
                setActivities(activities.map(activity => activity.id === id ? data : activity));
            })
            .catch(error => {
                console.error(error);
                setErrorMessage(error.message);
            });
    };

    return (
        <div className="activitiesPage">
            <h1 className="pageTitle">Activities</h1>

            {errorMessage && <div className="errorMessage">{errorMessage}</div>}

            <div className="createActivity">
                <h2>Create New Activity</h2>
                <input
                    type="text"
                    placeholder="Name"
                    value={newActivity.name}
                    onChange={(e) => setNewActivity({ ...newActivity, name: e.target.value })}
                />
                <input
                    type="date"
                    value={newActivity.date}
                    onChange={(e) => setNewActivity({ ...newActivity, date: e.target.value })}
                />
                <textarea
                    placeholder="Description"
                    value={newActivity.description}
                    onChange={(e) => setNewActivity({ ...newActivity, description: e.target.value })}
                ></textarea>
                <button className="addButton" onClick={handleAddActivity}>Add Activity</button>
            </div>

            <div className="activitiesList">
                <h2>Your Activities</h2>
                <ul>
                    {activities.map((activity, index) => (
                        <li key={activity.id || index} className="activityItem">
                            <h3>{activity.name}</h3>
                            <p>{activity.date}</p>
                            <p>{activity.description}</p>
                            <button className="deleteButton" onClick={() => handleDeleteActivity(activity.id)}>Delete</button>
                            <button className="updateButton" onClick={() => handleUpdateActivity(activity.id, { ...activity, name: 'Updated Name' })}>Update</button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ActivitiesPage;
